import React from 'react';
import { GoogleTagManager } from 'src/services/GoogleTagManager';
import { ReactQueryClientProvider } from './ReactQueryClientProvider';
import { ReactCookiesProvider } from './ReactCookiesProvider';
import { ThemeProvider } from './ThemeProvider';
import 'src/lib/services/meta-pixel';
import { PostHogProvider } from 'src/providers/posthog';
import { canny } from 'src/lib/services/canny';
import { stripe } from 'src/lib/services/stripe';
import { UserGuidingPingProvider } from 'src/lib/services/user-guiding';

GoogleTagManager.init();

// Load third-party SDKs in parallel (except HubSpot — deferred to useHubSpotWidgetVisibility
// so it only loads after WebView detection settles, preventing widget flash in mobile apps)
// Using Promise.allSettled to ensure one failure doesn't block others
Promise.allSettled([
  canny.load(),
  stripe.load(),
]).then((results) => {
  const sdkNames = ['Canny', 'Stripe'];

  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.error(`Failed to load ${sdkNames[index]} SDK:`, result.reason);
    }
  });
});

type Props = React.PropsWithChildren;

const Providers: React.FC<Props> = (props) => {
  return (
    <PostHogProvider>
      <ReactQueryClientProvider>
        <UserGuidingPingProvider />

        <ReactCookiesProvider>
          <ThemeProvider>{props.children}</ThemeProvider>
        </ReactCookiesProvider>
      </ReactQueryClientProvider>
    </PostHogProvider>
  );
};

export default Providers;
